import { render, staticRenderFns } from "./Stand.vue?vue&type=template&id=0b0647f8&"
import script from "./Stand.vue?vue&type=script&lang=js&"
export * from "./Stand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports